<div class="ndf-management-grid">
  <div class="ndf-management-grid__aside">
    <div class="ndf-management-grid__aside__header"></div>
    <div
      *ngFor="let item of asideLabels; let iItem = index"
      class="ndf-management-grid__aside__item"
      [ngClass]="{
        'ndf-management-grid__aside__item--border': !!item?.label,
        'ndf-management-grid__aside__item--border--empty': !item?.label,
        'ndf-management-grid__aside__item--bold': !!item?.highlight,
      }">
      {{ item?.label }}
    </div>
    <form *ngIf="formFee" [formGroup]="formFee" appAutoFormGroup>
      <ng-container formArrayName="fees">
        <ng-container *ngFor="let fee of formFee.controls.fees.controls; let i = index">
          <div [formGroupName]="i">
            <div
              class="ndf-management-grid__aside__item ndf-management-grid__aside__item--border align-items-center p-0">
              <div class="h-100 w-50 border-right py-3 px-2 d-flex align-items-center">
                <label
                  >{{ tk.Management.NdfScenario | t }} <b>{{ getLetterFromIndex(i) }}</b></label
                >
              </div>
              <div class="h-100 w-50 py-3 px-2 d-flex align-items-center">
                <p-inputNumber
                  formControlName="scenarioValue"
                  [placeholder]="(tk.Management.NdfInsertFee | t) || ''"
                  [required]="false"
                  class="input__input--clean"
                  [inputStyleClass]="'input__input--clean'"
                  locale="pt-BR"
                  [minFractionDigits]="4"
                  mode="decimal"
                  min="0,00"
                  [disabled]="!demandPermissions.UPDATE"
                  (onInput)="onInputFeeDebounced($event, i)"></p-inputNumber>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </form>

    <div
      class="ndf-management-grid__aside__item ndf-management-grid__aside__item--border justify-content-center">
      <app-button
        class="m-0 w-100 pt-4"
        [id]="'cancel-register'"
        label=""
        [icon]="'pi pi-plus-circle'"
        [type]="'button'"
        [theme]="'link'"
        [disabled]="disableFees"
        (sendButtonClick)="addFee()">
      </app-button>
    </div>
  </div>

  <div class="ndf-management-grid__content" #content>
    @for (operation of operations; track operation.id; let iOperation = $index) {
      <app-ndf-management-item
        [ndfOperation]="operation"
        [financialInstitutionsOptions]="financialInstitutionsOptions"
        [index]="iOperation"
        [demand]="demand"
        (sendDemand)="handleDemandChange($event)"
        (sendOperationAction)="handleOperationAction($event)">
      </app-ndf-management-item>
    }
  </div>
</div>
